import { Failure } from '@mrhenry/failure';
import { html, TemplateResult } from 'lit';
import { live } from 'lit/directives/live.js';
import { classMap } from 'lit/directives/class-map.js';
import { Dispatcher } from '../../../types/booking-request';
import { staticText } from '../../../static-text';

export function emailInput(
	email: string,
	dispatch: Dispatcher,
	assetUrl: string,
	emailFailure?: Failure
): TemplateResult {
	const changeHandler = ( e: InputEvent ) => {
		if ( !( e.target instanceof HTMLInputElement ) ) {
			throw new Error( 'e.target should be instanceof HTMLInputElement' );
		}

		const value = e.target.value;
		if ( !value || '' === value ) {
			dispatch( {
				type: 'UPDATE_EMAIL',
				email: value,
				emailFailure: Failure.from( staticText.emailIsRequiredFailureMessage ),
			} );

			return;
		}

		if ( !e.target.checkValidity() ) {
			dispatch( {
				type: 'UPDATE_EMAIL',
				email: value,
				emailFailure: Failure.from( staticText.emailMustBeValidFormatFailureMessage ),
			} );

			return;
		}

		dispatch( {
			type: 'UPDATE_EMAIL',
			email: value,
		} );
	};

	const classes = {
		'has-error': emailFailure !== undefined,
	};

	let failure = html``;
	if ( Failure.isFailure( emailFailure ) ) {
		failure = html`
			<p class="form__field-validation-error theme-color-error">
				<img alt="" class="form__field-validation-error__icon" src="${assetUrl}/assets/images/alert-circle.svg">
				${emailFailure?.message}
			</p>
		`;
	}

	return html`
		<div class="form__row ${classMap( classes )}">
			<div class="form__label-container type-d">
				<label class="form__label" for="email">
					${staticText.emailCapitalizedRequired}
				</label>
			</div>

			<input
				.value=${live( email )}
				@change=${changeHandler}
				class="form__input"
				id="email"
				name="email"
				type="email"
			/>

			${failure}
		</div>
	`;
}
